module.exports = __webpack_public_path__ + "img/zhuym.61525dd4.png";